// SYNCED FROM: VidaReactNative/src/features/AddressVerification/utils/buildVerifyRequest.ts
// Keep in sync. See SYNC.md.
import type { LobVerifyRequest } from '../api/lobApi';
import type { Address } from '../types';

/**
 * Map a trimmed user address to the snake_case Lob verification request body.
 * Empty `city`, `state`, and `zip` are coerced to `undefined` so Lob doesn't
 * interpret an empty string as user intent. `secondary_line` is already
 * optional on the input address (post-trim) and passes through directly.
 */
export const buildVerifyRequest = (address: Address): LobVerifyRequest => ({
  primary_line: address.addressLine1,
  secondary_line: address.addressLine2,
  city: address.city || undefined,
  state: address.state || undefined,
  zip_code: address.zip || undefined,
});
